import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  submit(event) {
    event.preventDefault()
    this.element.querySelector("vipps-mobilepay-button").setAttribute("loading", "true")
    this.element.requestSubmit()
  }
}
